(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-html-page"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".tabs li a");
  const tabContents = document.querySelectorAll(".tab--content");

  if (tabLinks.length > 0) {
    tabLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        let target = this.getAttribute("href"); // Example: #tab-1

        // Remove active class from all tabs
        tabLinks.forEach((l) => l.parentElement.classList.remove("active"));
        tabContents.forEach((content) => content.classList.remove("active"));

        // Add active class to clicked tab
        this.parentElement.classList.add("active");

        // Show tab content
        document.querySelector(target).classList.add("active");
      });
    });

    // Open first tab by default
    tabLinks[0].parentElement.classList.add("active");
    tabContents[0].classList.add("active");
  }
});


  } catch(e) { console.error(e); }
})();
})();
